export default __webpack_public_path__ + "static/media/Imagen2.cb4cadf4.jpg";